/* eslint-disable */
import {
  FormValidator
} from "@syncfusion/ej2-inputs";

const mixin = {
  data() {
    return {
      ipv4: '^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$',
      ipv6: '^\\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))(%.+)?\\s*$',
      time: '^(20|21|22|23|[0-1]\\d):[0-5]\\d:[0-5]\\d\\s\\d{3}$|(20|21|22|23|[0-1]\\d):[0-5]\\d:[0-5]\\d$',
      date: '^(\\d{4})[-.](0?[1-9]|1[012])[-.](0?[1-9]|[12][0-9]|3[01])$',
      datemin: '^(\\d{4})-(0?[1-9]|1[012])-(0?[1-9]|[12][0-9]|3[01]) (20|21|22|23|[0-1]\\d):[0-5]\\d$',
      integer: '^-?\\d+$',
      specialWord: '^[\u4e00-\u9fa5_a-zA-Z0-9]+$',
      specialWordWithSpace: '^([\u4e00-\u9fa5_a-zA-Z0-9.]+$)|([\u4e00-\u9fa5_a-zA-Z0-9.]+[ \u4e00-\u9fa5_a-zA-Z0-9.]+$)',
      specialEn: '^[_a-zA-Z0-9]+$',
      longitude: '^(\\-|\\+)?(((\\d|[1-9]\\d|1[0-7]\\d|0{1,3})\\.\\d{0,6})|(\\d|[1-9]\\d|1[0-7]\\d|0{1,3})|180\\.0{0,6}|180)$',
      latitude: '^(\\-|\\+)?([0-8]?\\d{1}\\.\\d{0,6}|90\\.0{0,6}|[0-8]?\\d{1}|90)$',
      taskNameCheck:'^[-_0-9a-zA-Z\u4E00-\u9FA5]+$',
      userIdListCheck:'^(\\d+,){0,9}\\d+$',
      userIdListCheckHss:'^(((sip:[+]?[1-9]{1}[0-9]{5,14}\\@[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?)|(tel:[+]{0,1}[1-9]{1}[0-9]{5,14})|([0-9]{1}[0-9]{5,14}\\@[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?))+,){0,9}((sip:[+]?[1-9]{1}[0-9]{5,14}\\@[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?)|(tel:[+]{0,1}[1-9]{1}[0-9]{5,14})|([0-9]{1}[0-9]{5,14}\\@[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?))$',
      // 缓存校验最大&最小字节数 eg. maxLength: {name1:xx,name2:xx}
      byteSizeCache: { maxLength: {}, minLength: {} },
      domainOrIp:'^((([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\\-]*[A-Za-z0-9])$)|^((\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$)'
    }
  },
  methods: {
    // map转换为json
    mapToJson(map) {
      return JSON.parse(JSON.stringify(this.strMapToObj(map)));
    },
    strMapToObj(strMap) {
      let obj = Object.create(null);
      for (let [k, v] of strMap) {
        obj[k] = v;
      }
      return obj;
    },
    // form表单换绑
    setFormValidate(formId, inputNames, options) {
      const optionsTemp = this.copyDeep(options);
      const obj = this.getValidateObj(inputNames);
      Object.keys(obj).forEach(key => {
        if (obj[key]) {
          delete optionsTemp.rules[key];
          // const dom = document.getElementById(formId);
          if (document.getElementById(key + '-info')) {
            document.getElementById(key + '-info').remove();
            document.getElementsByName(key)[0].classList.remove('e-error');
            // dom.querySelector(`input[name=${key}]`).classList.remove('e-error');
          }
        }
      });
      return new FormValidator('#' + formId, optionsTemp);
    },
    copyDeep(data) {
      const returnData = {};
      returnData.customPlacement = data.customPlacement;
      returnData.rules = data.rules;
      return returnData;
    },
    getValidateObj(inputNames) {
      const obj = {};
      inputNames.forEach(item => {
        obj[item] = document.getElementsByName(item)[0].disabled;
      });
      return obj;
    },
    // form表单绑定
    validateForm(formId, inputNames, rules, customPlacement){
      // inputNames: list , rules: {}
      const options = this.formRules(rules,customPlacement);
      return this.setFormValidate(formId, inputNames, options);
    },
    formRules(obj,customPlacement) {
      // obj = { inputName1: { required: true, number: true, range:[1, 2], min: 1, max: 2, regex: 'ipv4'}, inputName2: {}}
      // regex: 'ipv4' 'ipv6' 'time' 'date' 'integer'
      const options = {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = "left";
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {}
      };
      if (customPlacement) {
        options.customPlacement = customPlacement;
      }
      for (let key in obj) {
        const inputRules = obj[key];
        options.rules[key] = {};
        for (let rule in inputRules) {
          if (rule === 'required') {
            options.rules[key][rule] = [inputRules[rule], `${this.$t('System.inputTip')}`];
          }
          if (rule === 'number') {
            options.rules[key][rule] = [inputRules[rule], `${this.$t('System.inputNumber')}`];
          }
          if (rule === 'min') {
            const trs = this.$t("Common.minValue") + inputRules[rule];
            options.rules[key][rule] = [inputRules[rule], trs];
          }
          if (rule === 'max') {
            const trs = this.$t("Common.maxValue") + inputRules[rule];
            options.rules[key][rule] = [inputRules[rule], trs];
          }
          if (rule === 'minLength'){
            let trs;
            // 若minLengthValue不为空，则是MML配置需要特殊处理的校验
            if (inputRules.minLengthValue) {
              trs = this.$t("Common.minByteNum") + inputRules.minLengthValue;
              this.byteSizeCache['minLength'][key] = inputRules.minLengthValue;
            } else {
              trs = this.$t("Common.minLength") + inputRules[rule];
            }
            options.rules[key][rule] = [inputRules[rule], trs];
          }
          if (rule === 'maxLength'){
            let trs;
            // 若maxLengthValue不为空，则是MML配置需要特殊处理的校验
            if (inputRules.maxLengthValue) {
              trs = this.$t("Common.maxByteNum") + inputRules.maxLengthValue;
              this.byteSizeCache['maxLength'][key] = inputRules.maxLengthValue;
            } else {
              trs = this.$t("Common.maxLength") + inputRules[rule];
            }
            options.rules[key][rule] = [inputRules[rule], trs];
          }
          if (rule === 'email'){
            options.rules[key][rule] = [inputRules[rule], this.$t('System.inputTipEmail')]
          }
          if (rule === 'range') {
            const trs = this.$t("Common.inputRange") + inputRules[rule];
            options.rules[key][rule] = [inputRules[rule], trs];
          }
          if (rule === 'regex') {
            if (inputRules[rule] === 'ipv4') {
              options.rules[key][rule] = [this.ipv4, `${this.$t('MML.notValidIpv4')}`];
            }
            if (inputRules[rule] === 'ipv6') {
              options.rules[key][rule] = [this.ipv6, `${this.$t('MML.notValidIpv6')}`];
            }
            if (inputRules[rule] === 'domainOrIp') {
              options.rules[key][rule] = [this.domainOrIp, `${this.$t('MML.notValidDomainOrIp')}`];
            }
            // if (inputRules[rule] === 'ipv6') {
            //   options.rules[key][rule] = [this.ipv6, `${this.$t('MML.notValidIpv6')}`];
            // }
            if (inputRules[rule] === 'time') {
              options.rules[key][rule] = [this.time, `${this.$t('MML.notValidTime')}`];
            }
            if (inputRules[rule] === 'date') {
              options.rules[key][rule] = [this.date, `${this.$t('MML.notValidDate')}`];
            }
            if (inputRules[rule] === 'integer') {
              options.rules[key][rule] = [this.integer, this.$t('MML.notValidInteger')];
            }
            if (inputRules[rule] === 'specialWord') {
              options.rules[key][rule] = [this.specialWord, this.$t('MCS.noSpecialChar')];
            }
            if (inputRules[rule] === 'specialWordWithSpace') {
              options.rules[key][rule] = [this.specialWordWithSpace, this.$t('MCS.noSpecialChar')];
            }
            if (inputRules[rule] === 'datemin') {
              options.rules[key][rule] = [this.datemin, this.$t('MML.notValidDate')];
            }
            if (inputRules[rule] === 'specialEn') {
              options.rules[key][rule] = [this.specialEn, this.$t('MCS.noSpecialChar')];
            }
            if (inputRules[rule] === 'longitude') {
              options.rules[key][rule] = [this.longitude, this.$t('System.mapLngLimit')];
            }
            if (inputRules[rule] === 'latitude') {
              options.rules[key][rule] = [this.latitude, this.$t('System.mapLatLimit')];
            }
            if (inputRules[rule] === 'taskNameCheck') {
              options.rules[key][rule] = [this.taskNameCheck, this.$t('Observe.invalidChart')];
            }
            if (inputRules[rule] === 'userIdListCheck') {
              options.rules[key][rule] = [this.userIdListCheck, this.$t('Observe.invalidFormat')];
            }
            if (inputRules[rule] === 'userIdListCheckHss') {
              options.rules[key][rule] = [this.userIdListCheckHss, this.$t('Observe.invalidFormat')];
            }
          }
        }
      }
      return options;
    },
    // 计算字符串所占字节数（UTF-8）
    computeByteSize(str) {
      let byteSize = 0;
      for (const chr of str) {
        //ES6提供了codePointAt方法，能够正确处理4个字节储存的字符，返回一个字符的码点
        const charCode = chr.codePointAt(0);
        if(0 <= charCode && charCode <= 0x7f) {
          byteSize += 1;
        } else if (128 <= charCode && charCode <= 0x7ff) {
          byteSize += 2;
        } else if (2048 <= charCode && charCode <= 0xffff) {
          byteSize += 3;
        } else if (65536 < charCode && charCode <= 0x1FFFFF) {
          byteSize += 4;
        } else if (0x200000 < charCode && charCode <= 0x3FFFFFF) {
          byteSize += 5;
        } else if (0x4000000 < charCode && charCode <= 0x7FFFFFFF) {
          byteSize += 6;
        } else {
          byteSize += 6;
        }
      }
      return byteSize;
    },
    maxBytesValidateFn(args) {
      const maxLength = this.byteSizeCache['maxLength'][args.element.name];
      return this.computeByteSize(args['value']) <= maxLength;
    },
    minBytesValidateFn(args) {
      const minLength = this.byteSizeCache['minLength'][args.element.name];
      return this.computeByteSize(args['value']) >= minLength;
    }
  }
};
export default mixin;
